import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  outcomesTitle: {
    id: 'course-authoring.schedule.learning-outcomes-section.title',
    defaultMessage: 'Learning outcomes',
  },
  outcomesDescription: {
    id: 'course-authoring.schedule.learning-outcomes-section.description',
    defaultMessage: 'Add the learning outcomes for this course',
  },
  outcomesDelete: {
    id: 'course-authoring.schedule.learning-outcomes-section.delete',
    defaultMessage: 'Delete',
  },
  outcomesAdd: {
    id: 'course-authoring.schedule.learning-outcomes-section.add',
    defaultMessage: 'Add learning outcome',
  },
  outcomesInputPlaceholder: {
    id: 'course-authoring.schedule.learning-outcomes-section.input.placeholder',
    defaultMessage: 'Add a learning outcome here',
  },
  outcomesLabelIncrement: {
    id: 'course-authoring.schedule.learning-outcomes-section.label-increment',
    defaultMessage: 'Learning outcome',
  },
});

export default messages;
